import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { CARD_TOGGLE_TYPES, DEVICE_TYPES, typeOf } from "../../constants/devices";
import { onOffPayload, sendControl } from "../../services/deviceControl";
import { switchFeedback } from "../../preferences/feedback";
import { User } from "../../storage/store";
import { useToggleTop } from "../common/ToggleTop";
import AppDeviceCard from "./app/AppDeviceCard";

// Card for switch-like devices. As in the app, the icon half switches lights,
// sockets, fans, switches, motors, dimmers and RGB lights on and off; IR
// blasters open their remotes, and vacuums and anything else their details.
const SwitchCard = ({ props }) => {
  const device = props;
  const navigate = useHistory();
  const toast = useToggleTop();
  const type = typeOf(device);
  const [on, setOn] = useState(device.props?.state === true);
  const [busy, setBusy] = useState(false);

  useEffect(() => setOn(device.props?.state === true), [device.props?.state]);

  // An IR blaster opens the list of remotes learned on it, as in the app.
  const isBlaster = type === DEVICE_TYPES.IRBM;
  const openDetails = () =>
    navigate.push(isBlaster ? "/remotes" : "/device", { data: device, propertyId: User.getPropertyId() });

  const toggle = async () => {
    const next = !on;
    setOn(next);
    setBusy(true);
    switchFeedback(next);
    try {
      await sendControl(onOffPayload(device, next));
      device.props.state = next;
    } catch (error) {
      setOn(!next);
      toast(`Couldn't switch ${device.name} ${next ? "on" : "off"}`, "red");
    } finally {
      setBusy(false);
    }
  };

  const canToggle = CARD_TOGGLE_TYPES.includes(type);

  return (
    <AppDeviceCard
      name={device.name}
      floor={device.floor}
      room={device.room}
      timeStamp={device.props?.timeStamp}
      type={type}
      active={on}
      busy={busy}
      centerIcon={isBlaster}
      onToggle={canToggle ? toggle : undefined}
      toggleLabel={`${device.name}, ${on ? "on" : "off"}. Switch ${on ? "off" : "on"}`}
      onOpen={openDetails}
    />
  );
};

export default SwitchCard;
